import PropertyRoomFacilityCard from './PropertyRoomFacilityCard';

export default PropertyRoomFacilityCard;
